/**
 * Session Not Found Page
 *
 * Error page displayed when session ID is invalid or not found.
 */

interface SessionNotFoundProps {
  sessionId: string;
}

/**
 * Session Not Found
 *
 * Displayed when:
 * - Session ID doesn't exist (404)
 * - Session ID is malformed
 * - Session has expired (410)
 */
export default function SessionNotFound({ sessionId }: SessionNotFoundProps) {
  return (
    <div
      style={{
        textAlign: 'center',
        maxWidth: '600px',
        margin: '2rem auto',
      }}
    >
      <h1>Session Not Found</h1>
      <p>
        The session with ID <code>{sessionId}</code> could not be found.
      </p>
      <div
        style={{
          marginTop: '2rem',
          padding: '1rem',
          background: '#f8f9fa',
          borderRadius: '4px',
          textAlign: 'left',
        }}
      >
        <p>
          <strong>Possible reasons:</strong>
        </p>
        <ul>
          <li>The session ID is incorrect or malformed</li>
          <li>The session has expired (30 minute TTL)</li>
          <li>The session was cancelled or completed</li>
        </ul>
      </div>
      <div style={{ marginTop: '2rem' }}>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '0.5rem 1rem',
            fontSize: '1rem',
            cursor: 'pointer',
            marginRight: '1rem',
          }}
        >
          Refresh Page
        </button>
        <a href="/" style={{ padding: '0.5rem 1rem' }}>
          Go to Home
        </a>
      </div>
    </div>
  );
}
